import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image";
import React from "react";
//
import { AppStoreButton } from "./AppStoreButton";
//
import { cl } from "../helpers/general";
import { useStaticQuery, graphql } from "gatsby";

const transition = "duration-200 ease-in";

interface Props {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DownloadAppPopup = (props: Props) => {
  const rawData = useStaticQuery(graphql`
    query {
      sanityBasicSettings {
        appQRCode {
          asset {
            gatsbyImageData(height: 150, width: 150)
          }
        }
        qrLabel
        androidAppUrl
        iosAppUrl
      }
    }
  `);

  const data = rawData.sanityBasicSettings;

  return (
    <div
      onClick={() => props.onClose(false)}
      className={cl(
        transition,
        props.isOpen && "opacity-100",
        !props.isOpen && "opacity-0 pointer-events-none",
        "fixed inset-0 z-50 flex items-center justify-center transition-opacity",
      )}
    >
      <div className={cl("fixed inset-0 opacity-80 bg-black")} />
      <div
        className={cl(
          transition,
          props.isOpen && "translate-y-0",
          !props.isOpen && "-translate-y-1",
          "flex-col flex items-center min-w-fit transition-transform border border-transparent bg-brand-four rounded-lg",
        )}
      >
        <div className="flex space-x-8 items-center mx-12 my-12">
          <GatsbyImage
            image={getImage(data.appQRCode.asset)!}
            className="rounded-lg border border-transparent"
            alt="download-app"
          />
          <div className="space-y-4">
            <div className="text-2xl">
              Scan QR code
              <br />
              {data.qrLabel}
            </div>
            <div className="flex items-center space-x-6">
              <AppStoreButton type="apple" />
              <AppStoreButton type="google" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
